import { render, staticRenderFns } from "./genre-grid-block.vue?vue&type=template&id=aaa946a2&scoped=true&"
import script from "./genre-grid-block.vue?vue&type=script&lang=js&"
export * from "./genre-grid-block.vue?vue&type=script&lang=js&"
import style0 from "./genre-grid-block.vue?vue&type=style&index=0&id=aaa946a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa946a2",
  null
  
)

export default component.exports